module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/pays_random_symbols@1x.png?1.0.17";